import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import Themes from './themes'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: Themes.chuspic
    }
  }
})

export default vuetify;
